import React, { useEffect, useRef, useState } from 'react'

const SIZES = {
  sm: 'px-2 py-2 text-sm',
  md: 'py-3 px-3'
}

export const Button = React.forwardRef((props, incomingRef) => {
  const { label, className, variant = 'primary', children, text = false, size = 'md', ...attrs } = props
  const [hover, setHover] = useState(false)
  const ref = useRef(incomingRef)

  let colors = []
  switch (variant) {
    case 'primary': {
      colors.push('text-slate-300')
      colors.push('bg-[#4F98BD]')
      break
    }
    case 'success': {
      colors.push('bg-green-600')
      break
    }
    case 'danger': {
      colors.push('bg-red-700')
      colors.push('text-red-400')
      break
    }
  }

  useEffect(() => {
    if (!ref.current) return

    ref.current.addEventListener('mouse', () => {})
  }, [ref.current])

  return (
    <button ref={ref} type="button" className={`leading-none hover:cursor-pointer ${SIZES[size]} ${className} ${!text && colors.join(' ')} ${!text && 'brightness-110 rounded-md bg-gradient-to-r hover:from-indigo-500 hover:via-purple-500 hover:to-pink-500'}`} {...attrs}>
      {children || label}
    </button>
  )
})
